import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Tab, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { Grid } from "@/comn/components";
import { useForm, useFetch, useModal, useStore, useToast, useResource, useTab, useGrid, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SF_TANSAD_DCLR_DTL,
    SG_TANSAD_DCLR_ITM_LST,
    SF_TANSAD_DCLR_ITM,
    SG_TANSAD_DCLR_VIA_CNTY_LST,
    SF_TANSAD_DCLR_ITM_VHCL,
    SG_TANSAD_DCLR_ITM_MDL_LST,
    SF_TANSAD_DCLR_ITM_MDL,
    SF_TANSAD_DCLR_ATCH,
    SG_TANSAD_DCLR_ATCH_LST,
    SG_TANSAD_DCLR_MDL_VLTN_LST,
} from "@/tz/go/egaz/osci/lpco/cscl/services/OsciTansadDclrService";
import { isEmpty } from "lodash";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * Declaration Details
 * !== TANSAD신고서 상세 ==!
 */
export const OSCI0202002Q = (props: any) => {
    /*
     * @ 변수에 대한 주석 (기본 Hook 제외)
     * @ 메타 시스템을 참고 하여 표준 단어와 용어를 사용하여 작성
     * @ 기본 한줄 주석 형태를 사용
     * @ 포맷
     * @ [지환부호시작] [한글변수명] [지환부호종료]
     *
     * 예시) const pgeUid = "CGME0411001Q"; // Page Unique identifier !== 화면 고유 식별자 ==!
     * 선언과 동시에 전개가 이루어 지는 경우 변수의 위쪽에 작성
     */

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0080" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "comnCd", comnCd: "OSC0025" },
            { area: "comnCd", comnCd: "OSC0027" },
            { area: "comnCd", comnCd: "OSC0028" },
            { area: "comnCd", comnCd: "OSC0029" },
            { area: "comnCd", comnCd: "OSC0030" },
            { area: "comnCd", comnCd: "OSC0031" },
            { area: "comnCd", comnCd: "OSC0033" },
            { area: "comnCd", comnCd: "OSC0034" },
            { area: "comnCd", comnCd: "OSC0042" },
            { area: "comnCd", comnCd: "OSC0051" },
            { area: "cstmCd" },
            { area: "cntyCd" },
            { area: "currCd" },
            { area: "wrhsCd" },
            { area: "bnkCd" },
            { area: "coCd" },
            { area: "hsCd" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        // Page Unique identifier !== 화면 고유 식별자 ==!
        auth: ["auth_osci0001", "auth_osci0002", "auth_osci0003"] /* OGA's TANSAD Information Access */,
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { id } = useParams(); // Key Parameter !== 넘어온 키 Parameter ==!

    // VIA COUNTRY LIST BY TPCD GRID!== 경유지 국가 리스트 ==!
    const [tansadDclrViaCntyLst, setTansadDclrViaCntyLst] = useState(comnUtils.getGridData([]));

    // List Menu SearchForm !== 목록조회 스테이트 ==!
    const [btnState, setBtnState] = useState(false);
    // List Menu SearchForm !== 목록조회 스테이트 ==!
    const [dtlState, setDtlState] = useState(false);
    // ITEM GRID !== 아이템 그리드 ==!
    const [tansadDclrItmLst, setTansadDclrItmLst] = useState(comnUtils.getGridData([]));
    // MODEL GRID !== 모델 그리드 ==!
    const [tansadDclrItmMdlList, setTansadDclrItmMdlList] = useState(comnUtils.getGridData([]));
    // ATTACH MENT GRID !== 첨부파일 그리드 ==!
    const [tansadDclrAtchList, setTansadDclrAtchList] = useState(comnUtils.getGridData([]));

    const [vhclState, setVhclState] = useState(false);
    const [viaCntyYn, setViaCntyYn] = useState(false);

    let cstmOfceCd: any;
    let tansadYy: any;
    let tansadSrno: any;

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // TANSAD Detail Select !== APC 상세 조회==!
        tansadDclrDtl: useForm({
            defaultSchema: SF_TANSAD_DCLR_DTL,
            defaultValues: [],
        }),
        // TANSAD Detail ITEM !== TANSAD ITEM 폼==!
        tansadDclrItm: useForm({
            defaultSchema: SF_TANSAD_DCLR_ITM,
            defaultValues: [],
        }),
        // TANSAD Detail VEHICLE !== TANSAD 차량 폼==!
        tansadDclrItmVhcl: useForm({
            defaultSchema: SF_TANSAD_DCLR_ITM_VHCL,
            defaultValues: [],
        }),
        // TANSAD Detail Model !== TANSAD 모델 폼==!
        tansadDclrItmMdl: useForm({
            defaultSchema: SF_TANSAD_DCLR_ITM_MDL,
            defaultValues: [],
        }),
        // TANSAD Detail Attachment !== TANSAD 첨부파일 폼==!
        tansadDclrAtch: useForm({
            defaultSchema: SF_TANSAD_DCLR_ATCH,
            defaultValues: [],
        }),
    };

    /*
     * @ 화면에서 사용하는 grid 객체를 선언
     * @ 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * @ 그리드 변수명 뒤에 List (List) 를 붙여 구분
     * @ const grid = {
     *      [grid 이름] : useWijmo({
     *          defaultSchema: [grid의 schema 구조],
     *          page: [페이지 번호, 기본 0부터 시작],
                size: [한 페이지에 보여줄 데이터 갯수],
     *      }),
     *      ...
     * }
     * 
     * Declaration Grid
     * !== 그리드 정의 ==! 
     */
    const grid = {
        // ITEM List !== TANSAD DECLARATION ITEM 목록 ==!
        tansadItmList: useGrid({
            defaultSchema: SG_TANSAD_DCLR_ITM_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        // MODEL List !== TANSAD DECLARATION MODEL 목록 ==!
        tansadDclrItmMdlList: useGrid({
            defaultSchema: SG_TANSAD_DCLR_ITM_MDL_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        // AttchFile List !== TANSAD DECLARATION Attach 목록 ==!
        tansadDclrAtchList: useGrid({
            defaultSchema: SG_TANSAD_DCLR_ATCH_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        // VIA COUNTRY  !== TANSAD 경유지 국가 목록 ==!
        tansadDclrViaCntyLst: useGrid({
            defaultSchema: SG_TANSAD_DCLR_VIA_CNTY_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        // AttchFile List !== TANSAD DECLARATION ITM VALUATION 목록 ==!
        tansadDclrMdlVltn: useGrid({
            defaultSchema: SG_TANSAD_DCLR_MDL_VLTN_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get APC Detaile Select !== APC 관리 상세 조회 ==!
        getTansadDclrGnrl: useFetch({
            api: (cstmOfceCd, tansadYy, tansadSrno) => {
                return APIS.getTansadDclrGnrl(cstmOfceCd, tansadYy, tansadSrno);
            },
            onSuccess: (data) => {
                const tansadDclrDto = data.tansadDclrDtlDto.content;

                const infoTansadAtcdLst = tansadDclrDto.infoTansadAtcdLst;
                const tansadDclrViaCntyLst = tansadDclrDto.tansadDclrViaCntyLst;

                if (!comnUtils.isEmpty(tansadDclrDto.osciTansadDclrRsltDto)) {
                    cstmOfceCd = tansadDclrDto.osciTansadDclrRsltDto.cstmOfceCd;
                    tansadYy = tansadDclrDto.osciTansadDclrRsltDto.tansadYy;
                    tansadSrno = tansadDclrDto.osciTansadDclrRsltDto.tansadSrno;

                    form.tansadDclrDtl.setValues({ ...tansadDclrDto.osciTansadDclrRsltDto });
                    handler.getTansadDclrItemLst();

                    // 첨부파일 그리드
                    if (!isEmpty(infoTansadAtcdLst)) {
                        setTansadDclrAtchList(comnUtils.getGridData(infoTansadAtcdLst));
                        form.tansadDclrAtch.setValues({ ...infoTansadAtcdLst[0] });

                        if (!comnUtils.isEmpty(infoTansadAtcdLst[0].fileNm)) {
                            if (
                                infoTansadAtcdLst[0].fileNm.includes("HTTP") ||
                                infoTansadAtcdLst[0].fileNm.includes("http")
                            ) {
                                form.tansadDclrAtch.setSchema("bsopId", {
                                    type: "text",
                                    value: infoTansadAtcdLst[0].docNm,
                                });
                            } else {
                                form.tansadDclrAtch.setSchema("bsopId", {
                                    type: "file",
                                    value: infoTansadAtcdLst[0].fileNm,
                                });
                            }
                        }
                    }

                    if (!comnUtils.isEmpty(tansadDclrViaCntyLst)) {
                        setViaCntyYn(true);
                        setTansadDclrViaCntyLst(comnUtils.getGridData(tansadDclrViaCntyLst));
                    }

                    setDtlState(true);
                    if (comnUtils.isPopup()) {
                        setBtnState(false);
                    } else {
                        setBtnState(true);
                    }
                } else {
                    setDtlState(false);
                    setBtnState(false);
                    modal.openModal({ content: "msg.osc.00050" }); // No data
                }
            },
            onError: (error) => {
                console.log(error);
            },
            showToast: true,
        }),
        getTansadDclrItmLst: useFetch({
            api: (data) => {
                return APIS.getTansadDclrItmLst(cstmOfceCd, tansadYy, tansadSrno);
            },
            onSuccess: (data: any) => {
                const tansadDclrItmLst = data.tansadDclrItmLst.content;

                setTansadDclrItmLst(comnUtils.getGridData(tansadDclrItmLst));

                if (setTansadDclrItmLst && setTansadDclrItmLst.length > 0 && tansadDclrItmLst[0]) {
                    const itmNo = tansadDclrItmLst[0].itmNo;
                    handler.getTansadDclrItm(
                        tansadDclrItmLst[0].cstmOfceCd,
                        tansadDclrItmLst[0].tansadYy,
                        tansadDclrItmLst[0].tansadSrno,
                        itmNo,
                    );
                }
            },
            onError: () => {},
        }),
        getTansadDclrItm: useFetch({
            api: (cstmOfceCd, tansadYy, tansadSrno, itmNo) => {
                return APIS.getTansadDclrItm(cstmOfceCd, tansadYy, tansadSrno, itmNo);
            },
            onSuccess: (data) => {
                const tansadDclrItmDto = data.tansadDclrItmDto.content;
                const vhclInfo = tansadDclrItmDto.tansadDclrVhclRsltDto;
                const tansadDclrItmMdl = tansadDclrItmDto.tansadDclrItmMdlRsltDto;

                // ITEM
                if (!comnUtils.isEmpty(tansadDclrItmDto.tansadDclrItmRsltDto)) {
                    form.tansadDclrItm.setValues(tansadDclrItmDto.tansadDclrItmRsltDto);
                }
                // VEHICLE
                if (!comnUtils.isEmpty(vhclInfo)) {
                    setVhclState(true);
                    form.tansadDclrItm.setValue("vehicleYn", "Y");
                    form.tansadDclrItmVhcl.setValues({
                        ...data.tansadDclrItmDto.content.tansadDclrVhclRsltDto,
                    });

                    const flTpCd = form.tansadDclrItmVhcl.getValue("flTpCd");

                    if (flTpCd == "004") {
                        form.tansadDclrItmVhcl.setValue("vhclTp", "Electric vehicle");
                        form.tansadDclrItmVhcl.setSchema("engnKwCapc", { label: "L_BTRY_CAPC" });
                    } else {
                        form.tansadDclrItmVhcl.setValue("vhclTp", "Fuel vehicle");
                        form.tansadDclrItmVhcl.setSchema("engnKwCapc", { label: "L_ENGN_KW_CAPC" });
                    }
                } else {
                    form.tansadDclrItm.setValue("vehicleYn", "N");
                    setVhclState(false);
                }
                // MODEL
                setTansadDclrItmMdlList(comnUtils.getGridData(tansadDclrItmMdl));

                if (setTansadDclrItmMdlList.length > 0) {
                    const itmNo = tansadDclrItmMdl[0].itmNo;
                    const mdlNo = tansadDclrItmMdl[0].mdlNo;
                    handler.getTansadDclrItmMdl(
                        tansadDclrItmMdl[0].cstmOfceCd,
                        tansadDclrItmMdl[0].tansadYy,
                        tansadDclrItmMdl[0].tansadSrno,
                        itmNo,
                        mdlNo,
                    );
                }
            },
            onError: (error) => {
                console.log(error);
            },
        }),
        getTansadDclrItmMdl: useFetch({
            api: (cstmOfceCd, tansadYy, tansadSrno, itmNo, mdlNo) => {
                return APIS.getTansadDclrItmMdl(cstmOfceCd, tansadYy, tansadSrno, itmNo, mdlNo);
            },
            onSuccess: (data) => {
                form.tansadDclrItmMdl.setValues({ ...data.tansadDclrItmMdlDto.content });
            },
            onError: (error) => {
                console.log(error);
            },
        }),
        getTansadDclrAtchDocDtl: useFetch({
            api: (cstmOfceCd, tansadYy, tansadSrno, tansadDocTpCd, docSrno) => {
                return APIS.getTansadDclrAtchDocDtl(cstmOfceCd, tansadYy, tansadSrno, tansadDocTpCd, docSrno);
            },
            onSuccess: (data) => {
                const atcdDto = data.tansadDclrAtcdDocDto.content;
                form.tansadDclrAtch.setValues({ ...data.tansadDclrAtcdDocDto.content });

                if (!comnUtils.isEmpty(atcdDto.fileNm)) {
                    if (atcdDto.fileNm.includes("HTTP") || atcdDto.fileNm.includes("http")) {
                        form.tansadDclrAtch.setSchema("bsopId", { type: "text", value: atcdDto.docNm });
                    } else {
                        form.tansadDclrAtch.setSchema("bsopId", { type: "file", value: atcdDto.bsopId });
                    }
                }
            },
            onError: (error) => {
                console.log(error);
            },
        }),
        lpcoRprtModal: useFetch({
            api: (appId: string) => {
                return APIS.getLpcoRprt(appId);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                    draggable: true,
                });
            },
        }),
    };

    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : APC 관리 그리드 클릭
     *      ...
     * }
     *
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getTansadDclrItemLst: () => {
            form.tansadDclrItm.handleSubmit(
                (data) => {
                    fetch.getTansadDclrItmLst.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        getTansadDclrItm: (cstmOfceCd: any, tansadYy: any, tansadSrno: any, itmNo: any) => {
            fetch.getTansadDclrItm.fetch(cstmOfceCd, tansadYy, tansadSrno, itmNo);
        },
        getTansadDclrItmMdl: (cstmOfceCd: any, tansadYy: any, tansadSrno: any, itmNo: any, mdlNo: any) => {
            fetch.getTansadDclrItmMdl.fetch(cstmOfceCd, tansadYy, tansadSrno, itmNo, mdlNo);
        },
    };

    const render = {
        grid_TansadItmList: {
            head: {},
            cell: {
                itmNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={(e) => {
                                e.preventDefault();

                                fetch.getTansadDclrItm.fetch(
                                    rowValues.cstmOfceCd,
                                    rowValues.tansadYy,
                                    rowValues.tansadSrno,
                                    rowValues.itmNo,
                                );
                            }}
                        >{`${value}`}</a>
                    );
                },
                cpc: (props: any) => {
                    const { binding, rowValues, value } = props;

                    const cpc = rowValues.epcCd + "/" + rowValues.apcCd;
                    return <span>{cpc}</span>;
                },
            },
        },

        grid_TansadItmMdlList: {
            cell: {
                mdlNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={(e) => {
                                e.preventDefault();

                                fetch.getTansadDclrItmMdl.fetch(
                                    rowValues.cstmOfceCd,
                                    rowValues.tansadYy,
                                    rowValues.tansadSrno,
                                    rowValues.itmNo,
                                    rowValues.mdlNo,
                                );
                            }}
                        >{`${value}`}</a>
                    );
                },
            },
        },

        grid_TansadDclrAtchList: {
            cell: {
                bsopId: (gridProps: any) => {
                    const { binding, rowValues, value } = gridProps;
                    // External URL attachment !== URL 첨부 ==!
                    if (!comnUtils.isEmpty(rowValues.atcdFileUrlAddr)) {
                        return (
                            <Layout direction="col" gap={1} align="center" valign="center">
                                <Button
                                    onClick={() => {
                                        const environment = process.env.REACT_APP_APM_ENVIRONMENT ?? "unknown";
                                        let fileUrlAddr = rowValues.atcdFileUrlAddr;
                                        if (environment == "development" || environment == "dev") {
                                            const path = fileUrlAddr.substring(
                                                fileUrlAddr.indexOf("/", fileUrlAddr.indexOf("://") + 3),
                                            );
                                            fileUrlAddr = "https://tanesw.cupia.or.kr" + path;
                                        }
                                        lpcoUtils.urlFileDownload(fileUrlAddr.replace(/\|/g, "%7C"));
                                    }}
                                >
                                    {t("B_DWNL")}
                                </Button>
                            </Layout>
                        );
                    }
                },
            },
        },
    };

    useEffect(() => {
        setBtnState(false);

        form.tansadDclrDtl.setEditable(false);
        form.tansadDclrItm.setEditable(false);
        form.tansadDclrItmMdl.setEditable(false);
        form.tansadDclrItmVhcl.setEditable(false);
        form.tansadDclrAtch.setEditable(false);

        if (!comnUtils.isEmpty(id)) {
            cstmOfceCd = id?.split("-")[0];
            tansadYy = id?.split("-")[1];
            tansadSrno = id?.split("-")[2];

            fetch.getTansadDclrGnrl.fetch(cstmOfceCd, tansadYy, tansadSrno);
            setBtnState(true);
        }
    }, []);

    const tabList = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: "L_GNRL" }, { label: "L_ITM" }, { label: "L_ATCD_FILE" }],
        },
    });

    /*
     * @ 라벨 생성(명명 규칙)
     * @ prefix
     * @ 일반라벨 : L_
     * @ 버튼 : B_
     * @ 제목 : T_
     * @ 메세지 : msg.00000 [msg.숫자5자리] , 00000 ~ 10000 까지는 공통영역
     * @ 매세지를 제외한 라벨은 메타 단어, 용어 조합, 메세지는 숫자 5자리 일련번호로 정의
     * @ 대문자로 표시
     * @ 단어와 단어 사이 용어와 용어 사이는 "_" 로 구분
     */
    return (
        <Page>
            {dtlState && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Label {...form.tansadDclrDtl.schema.referenceNo}></Group.Label>
                                <Group.Field size={4}>
                                    <Group.Control {...form.tansadDclrDtl.schema.reffTin} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.tansadDclrDtl.schema.reffYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.tansadDclrDtl.schema.reffSrno} />
                                </Group.Field>
                                <Group.Control {...form.tansadDclrDtl.schema.reffDtm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Label {...form.tansadDclrDtl.schema.tansadNo}></Group.Label>
                                <Group.Field size={4}>
                                    <Group.Control {...form.tansadDclrDtl.schema.cstmOfceCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.tansadDclrDtl.schema.tansadYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.tansadDclrDtl.schema.tansadSrno} />
                                </Group.Field>
                                <Group.Control {...form.tansadDclrDtl.schema.tansadDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.tansadDclrDtl.schema.decrModeCd} />
                                <Group.Control {...form.tansadDclrDtl.schema.csclPrcssCstm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.tansadDclrDtl.schema.godsLoctReffCn} />
                                <Group.Control {...form.tansadDclrDtl.schema.entryCstmOfceCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.tansadDclrDtl.schema.dclrPrcssSttsCd} />
                                <Group.Control {...form.tansadDclrDtl.schema.sltvRsltCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.tansadDclrDtl.schema.suspdYn} />
                                <Group.Control {...form.tansadDclrDtl.schema.cncltnRcveYn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.tansadDclrDtl.schema.dsmsYn} />
                                <Group.Control {...form.tansadDclrDtl.schema.dsmsCd} />
                            </Group.Row>
                        </Group.Section>

                        <Tab {...tabList.tab}>
                            <Tab.Panel>
                                <Group.Title title="General" titleSize={1} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.csclPlnCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.tansadFmTpCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.totPckgNo} />
                                        <Group.Control {...form.tansadDclrDtl.schema.pckgUtCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.gwght} />
                                        <Group.Control {...form.tansadDclrDtl.schema.nwght} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.ucrNo} />
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Trade Operators" titleSize={1} />
                                <Group.Title title="Country" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.csmCntyCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.trdeCntyCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.expCntyCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.dstnCntyCd} />
                                    </Group.Row>
                                </Group.Section>
                                <br></br>
                                {viaCntyYn && (
                                    <>
                                        <Group.Title title="Via Country" titleSize={2} />
                                        <Group.Section>
                                            <Grid {...grid.tansadDclrViaCntyLst.grid} data={tansadDclrViaCntyLst} />
                                        </Group.Section>
                                    </>
                                )}
                                <Group.Title title="Exporter" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.exppnTin} />
                                        <Group.Control {...form.tansadDclrDtl.schema.expCoNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.expCoAddr} />
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Importer" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.imppnTin} />
                                        <Group.Control {...form.tansadDclrDtl.schema.impCoNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.impCoAddr} />
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Declarant" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.dcltTin} />
                                        <Group.Control {...form.tansadDclrDtl.schema.dclrCoNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.dclrCoAddr} />
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Financial" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.incoCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.hndvPlcCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.dclrInvcNo} />
                                        <Group.Control {...form.tansadDclrDtl.schema.invcDt} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.totInvcAmt} />
                                        <Group.Control {...form.tansadDclrDtl.schema.currCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.payMeanDstcCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.invcExrt} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.bnkCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.payAcctNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.secuDstcCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.secuAcctNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Label {...form.tansadDclrDtl.schema.natTrpt}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrDtl.schema.trptNatCd} />
                                            <Group.Control {...form.tansadDclrDtl.schema.trscNatuBaseCd} />
                                        </Group.Field>
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Valuation Note" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Label {...form.tansadDclrDtl.schema.xtrnFrghLb}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrDtl.schema.xtrnFrghAmt} />
                                            <Group.Control {...form.tansadDclrDtl.schema.xtrnFrghCurrCd} />
                                        </Group.Field>
                                        <Group.Label {...form.tansadDclrDtl.schema.insrLb}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrDtl.schema.insrAmt} />
                                            <Group.Control {...form.tansadDclrDtl.schema.insrCurrCd} />
                                        </Group.Field>
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Label {...form.tansadDclrDtl.schema.othrCostLb}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrDtl.schema.othrCost} />
                                            <Group.Control {...form.tansadDclrDtl.schema.othrCostCurrCd} />
                                        </Group.Field>
                                        <Group.Label {...form.tansadDclrDtl.schema.ddctLb}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrDtl.schema.ddctAmt} />
                                            <Group.Control {...form.tansadDclrDtl.schema.ddctCurrCd} />
                                        </Group.Field>
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.totStstclVal} />
                                        <Group.Control {...form.tansadDclrDtl.schema.totCstmVal} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.prevValtnPayYn} />
                                    </Group.Row>
                                </Group.Section>
                                <Group.Title title="Transportation" titleSize={2} />
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.csclTrptModeCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.trptMeanReffCn} />
                                        <Group.Control {...form.tansadDclrDtl.schema.trptNatCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.crn} />
                                        <Group.Control {...form.tansadDclrDtl.schema.arvlDt} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.blNo} />
                                        <Group.Control {...form.tansadDclrDtl.schema.blPrtlYn} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.vsslNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.shpmRegnCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.dscgPlcCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.dscgDt} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.totCntrCnt} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.cntrNo} controlSize={10} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.wrhsCd} />
                                        <Group.Control {...form.tansadDclrDtl.schema.prevWrhsCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.wrhsPridDays} />
                                        <Group.Control {...form.tansadDclrDtl.schema.cagRcptDclaReffNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrDtl.schema.stfngRprtNo} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Tab.Panel>
                            <Tab.Panel>
                                <Group.Title title="Item" titleSize={1} />
                                <Group.Section>
                                    <Grid
                                        {...grid.tansadItmList.grid}
                                        data={tansadDclrItmLst}
                                        render={render.grid_TansadItmList}
                                    />
                                </Group.Section>
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.itmNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.hs8Cd} />
                                        <Group.Control {...form.tansadDclrItm.schema.godsHsDesc1} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.hs4Cd} />
                                        <Group.Control {...form.tansadDclrItm.schema.godsHsDesc2} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.tansadDclrItm.schema.pckgPartMarkNo1}
                                            controlSize={10}
                                        />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control
                                            {...form.tansadDclrItm.schema.pckgPartMarkNo2}
                                            controlSize={10}
                                        />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.origCntyCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Label {...form.tansadDclrItm.schema.cpc}></Group.Label>
                                        <Group.Field size={4}>
                                            <Group.Control {...form.tansadDclrItm.schema.epcCd} />
                                            <Group.Control {...form.tansadDclrItm.schema.apcCd} />
                                        </Group.Field>
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.pfrnReffCn} />
                                        <Group.Control {...form.tansadDclrItm.schema.valtnMetdCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.brndNm} />
                                        <Group.Control {...form.tansadDclrItm.schema.tansadSbmtPupsCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.vatExmpnAplyNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.preTansadNo} />
                                        <Group.Control {...form.tansadDclrItm.schema.prevTansadDtm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.prevTansadItmNo} />
                                        <Group.Label {...form.tansadDclrItm.schema.ltrReffLb}></Group.Label>
                                        <Group.Field colSize={4}>
                                            <Group.Control {...form.tansadDclrItm.schema.exmpnKndCd} />
                                            <Group.Control {...form.tansadDclrItm.schema.ltrReffNo} />
                                        </Group.Field>
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.itmQty} />
                                        <Group.Control {...form.tansadDclrItm.schema.itmQtyUtCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.dtyBaseVal} />
                                        <Group.Control {...form.tansadDclrItm.schema.spfcCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.gwght} />
                                        <Group.Control {...form.tansadDclrItm.schema.nwght} />
                                    </Group.Row>
                                    {form.tansadDclrDtl.getValue("decrModeCd") == "IM7" && (
                                        <>
                                            <Group.Row>
                                                <Group.Control {...form.tansadDclrItm.schema.itmXtrnFrghAmt} />
                                                <Group.Control {...form.tansadDclrItm.schema.itmXtrnFrghTzsAmt} />
                                            </Group.Row>
                                            <Group.Row>
                                                <Group.Control {...form.tansadDclrItm.schema.itmInsrAmt} />
                                                <Group.Control {...form.tansadDclrItm.schema.itmInsrTzsAmt} />
                                            </Group.Row>
                                        </>
                                    )}
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.itmCstmVal} />
                                        <Group.Control {...form.tansadDclrItm.schema.itmStstclVal} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItm.schema.vehicleYn} />
                                        <Group.Control {...form.tansadDclrItm.schema.drwbSpfcCd} />
                                    </Group.Row>
                                </Group.Section>
                                {vhclState && (
                                    <Group.Section>
                                        <Group.Title title="Vehicle" titleSize={1} />
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclTp} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.spfcVhclYn} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.spfcVhclCmntCn} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.chssNo} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclMnfcYy} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclMkerCd} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclMdlCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclMdlNoCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclPrplTpCd} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclBodyTpCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclTrmssnTpCd} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclCtgrCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.tareWght} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclGwght} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.engnNo} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.seatCapc} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclPuchDt} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclClrCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.engnCubcCapc} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.engnKwCapc} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.engnHpCapc} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.axleNo} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.axleDste} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclOwrCtgrCd} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclUseCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.flTpCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.sarpcoCrteNo} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.frgnrRgsrNo} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.insrCoNm} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.insrNo} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclInsrTpCd} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.vhclImpCntyCd} />
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.insrStrtDt} />
                                            <Group.Control {...form.tansadDclrItmVhcl.schema.insrXpirDt} />
                                        </Group.Row>
                                    </Group.Section>
                                )}
                                <Group.Title title="Model" titleSize={1} />
                                <Group.Section>
                                    <Grid
                                        {...grid.tansadDclrItmMdlList.grid}
                                        data={tansadDclrItmMdlList}
                                        render={render.grid_TansadItmMdlList}
                                    />
                                </Group.Section>
                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItmMdl.schema.stndCmdtCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItmMdl.schema.mdlSpecCn} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItmMdl.schema.prevTansadMdlNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItmMdl.schema.itmQty} />
                                        <Group.Control {...form.tansadDclrItmMdl.schema.itmQtyUtCd} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrItmMdl.schema.utVal} />
                                        <Group.Control {...form.tansadDclrItmMdl.schema.itmInvcAmt} />
                                    </Group.Row>
                                </Group.Section>
                            </Tab.Panel>
                            <Tab.Panel>
                                <Group.Section>
                                    <Grid
                                        {...grid.tansadDclrAtchList.grid}
                                        data={tansadDclrAtchList}
                                        render={render.grid_TansadDclrAtchList}
                                        // onCellClick={(data: any) => {
                                        //     const cstmOfceCd = data.rowValues.cstmOfceCd;
                                        //     const tansadYy = data.rowValues.tansadYy;
                                        //     const tansadSrno = data.rowValues.tansadSrno;
                                        //     const tansadDocTpCd = data.rowValues.tansadDocTpCd;
                                        //     const docSrno = data.rowValues.docSrno;

                                        //     fetch.getTansadDclrAtchDocDtl.fetch(
                                        //         cstmOfceCd,
                                        //         tansadYy,
                                        //         tansadSrno,
                                        //         tansadDocTpCd,
                                        //         docSrno,
                                        //     );
                                        // }}
                                    />
                                </Group.Section>
                                {/* <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrAtch.schema.docDesc} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrAtch.schema.tansadDocTpCd} />
                                        <Group.Control {...form.tansadDclrAtch.schema.tansadReffItmNo} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrAtch.schema.bsopId} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrAtch.schema.issOrgNm} />
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.tansadDclrAtch.schema.issDt} />
                                        <Group.Control {...form.tansadDclrAtch.schema.frstRgsrDtm} />
                                    </Group.Row>
                                </Group.Section> */}
                            </Tab.Panel>
                        </Tab>
                    </Group.Body>
                </Group>
            )}

            {btnState && (
                <>
                    <Layout>
                        <Layout.Left>
                            {
                                <Layout.Button
                                    onClick={() => {
                                        navigate(`${URLS.osci0202001q}`);
                                    }}
                                >
                                    {t("L_LST")}
                                </Layout.Button>
                            }
                        </Layout.Left>
                    </Layout>
                </>
            )}
        </Page>
    );
};
